import { DynamicStyleSheet } from '@pulsar/core';
import { Platform } from 'src/libs/platform';

export default DynamicStyleSheet.create(theme => ({
  sheet: {
    flexShrink: 1,
    backgroundColor: theme.colors.sheetBG,
    // @todo is this right?
    maxWidth: 700,
    marginHorizontal: 'auto',
    ...Platform.select({
      ios: {
        borderTopLeftRadius: 14,
        borderTopRightRadius: 14,
      },
      default: {
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
      },
    }),
  },
}));
